<footer class="footer">
        <span>{{year}} Copyright&#64;StraViso</span>
</footer>